/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { assign } from "xstate";

export const successAction = assign((context: any, event: any) => ({
  payload: {
    ...context?.payload,
    ...event?.data,
  },
  result: {
    ...event?.data,
  },
}));
export const failureAction = assign((context: any, event: any) => ({
  payload: {
    ...context?.payload,
    ...event?.data,
  },
  result: {
    ...event?.data,
  },
}));
export const resetAction = assign((context: any, event: any) => ({
  payload: null,
  context: {},
}));

export const onEntryAction = (context: any, event: any) => {
  // console.log('on entry !!!!!!!');
};

export const onExitAction = (context: any, event: any) => {
  // console.log('on exit !!!!!!!!!!');
};

export const onErrorAction = (context: any, event: any) => {
  const e = event?.data;
};
